export default "__VITE_PUBLIC_ASSET__34dad8d3__"